import { createSlice } from "@reduxjs/toolkit";
import { fetchTemplates, addTemplate, updateTemplate, deleteTemplate, setDefaultTemplate } from "./thunks";

const defaultTemplates = [
  {
    id: 1,
    heading: "Service Reminder",
    subject: "Service Reminder - Action Required",
    description: "<p>Dear <strong>[CUSTOMER_NAME]</strong>,</p><p>This is a reminder that your <strong>[SERVICE_TYPE]</strong> is due on <strong>[NEXT_DATE]</strong>.</p><p>Please contact us to schedule your service.</p>",
    isDefault: true,
    isPredefined: true
  },
  {
    id: 2,
    heading: "Overdue Service",
    subject: "Overdue Service Notice",
    description: "<p>Dear <strong>[CUSTOMER_NAME]</strong>,</p><p>Your <strong>[SERVICE_TYPE]</strong> is overdue. Please contact us immediately to schedule your service.</p>",
    isDefault: false,
    isPredefined: true
  },
  {
    id: 3,
    heading: "Confirmation",
    subject: "Service Scheduled",
    description: "<p>Dear <strong>[CUSTOMER_NAME]</strong>,</p><p>Your <strong>[SERVICE_TYPE]</strong> is scheduled for <strong>[NEXT_DATE]</strong>. Thank you for choosing our services.</p>",
    isDefault: false,
    isPredefined: true
  }
];

const initialState = {
  templates: defaultTemplates,
  loading: false,
  error: null,
};

const emailTemplatesSlice = createSlice({
  name: "EmailTemplates",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchTemplates.pending, state => { state.loading = true; })
      .addCase(fetchTemplates.fulfilled, (state, action) => {
        state.loading = false;
        // If API returns templates, use them; otherwise keep defaults
        state.templates = (action.payload && action.payload.length > 0) ? action.payload : defaultTemplates;
      })
      .addCase(fetchTemplates.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
        // On error, keep the default templates
        state.templates = defaultTemplates;
      })
      .addCase(addTemplate.fulfilled, (state, action) => {
        state.templates.push(action.payload);
      })
      .addCase(updateTemplate.fulfilled, (state, action) => {
        const idx = state.templates.findIndex(t => t.id === action.payload.id);
        if (idx !== -1) state.templates[idx] = action.payload;
      })
      .addCase(deleteTemplate.fulfilled, (state, action) => {
        state.templates = state.templates.filter(t => t.id !== action.meta.arg);
      })
      .addCase(setDefaultTemplate.fulfilled, (state, action) => {
        state.templates = state.templates.map(t => ({ ...t, isDefault: t.id === action.payload.id }));
      });
  },
});

export default emailTemplatesSlice.reducer;
